/**
 * Shown when a user attempts to start a converting trial (e.g. an addon trial) that is already part
 * of a pending plan change / scheduled ramp on their account. Surfaced at the email gate. Mirrors
 * AddonIncluded (no CTA). Thin wrapper over the shared CheckoutMessage layout.
 *
 * The fallbacks below are only reached on direct navigation — normally the backend's EligibleResponse
 * supplies message/description through navigation state, already localized server-side. They resolve
 * from the UI catalog (public/translation/{locale}/internal/UIMessages.csv) using the same
 * useSelector(getTranslation) + t_message pattern as the rest of the checkout pages.
 *
 * The catalog values reuse the backend's own translations for this page
 * (checkout.message.addon_already_pending in vv-I18n), so the customer sees the same wording whether
 * they arrive with navigation state or land here directly. The backend's message is a verb phrase it
 * prefixes with the addon's name; the fallback has no name to prefix, so it carries the subject each
 * locale's description already uses.
 */

import React from 'react'
import { useSelector } from 'react-redux'
import CheckoutMessage from '../../../components/checkoutMessage'
import { getTranslation } from '../../../reducers/translation'
import { TRANSLATION_TYPE } from '../../../utils/constants'

function TrialPending() {
    const t = useSelector(getTranslation)
    const t_message = t[TRANSLATION_TYPE.MESSAGE] ?? {}

    return (
        <CheckoutMessage
            fallbackMessage={
                t_message?.['checkout.message.trial_pending']
                ?? 'This trial is already part of your pending plan change'
            }
            fallbackDescription={
                t_message?.['checkout.message.trial_pending_description']
                ?? "This trial is already scheduled on your account, so there's nothing more to add."
            }
        />
    )
}

export default TrialPending
